// extracted by mini-css-extract-plugin
module.exports = {"container":"MakePaymentHeader_container__xDB0x","logo":"MakePaymentHeader_logo__3HqNF","menu":"MakePaymentHeader_menu__38Ytj","myAccount":"MakePaymentHeader_myAccount__lf_fM"};